//MOBILE MENU & REWARDS BTN
const mobile_menu = document.querySelector('#mobile-menu-drawer');

var menu_observer = new MutationObserver(function(mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.type === "attributes") {
            hideShowRewards();
        }
    });
});

menu_observer.observe(mobile_menu, {
    attributes: true //configure it to listen to attribute changes
});

function hideShowRewards() {
    const rewards_btn = document.querySelector('#smile-ui-container');
    if (mobile_menu.hasAttribute('open')) {
        rewards_btn.style.opacity = "0";
        rewards_btn.style.visibility = "hidden"; 
        setTimeout(function(){
            rewards_btn.style.display = "none"; 
        }, 1000);
    } else {
        rewards_btn.style.display = "block"; 
        setTimeout(function(){
            rewards_btn.style.opacity = "1";
            rewards_btn.style.visibility = "visible";           
        }, 1000);
    }
}
